// extracted by mini-css-extract-plugin
export default {"avatar":"ArticleBody_avatar__W2DtY"};